import { useState, useEffect } from 'react';
import { mapPartnerDataToFormDefaults } from '../services/partner';
import type { ILeadsService } from '../services/leads';
import type { FormDefaults } from '../services/formDefaults';

export type UsePartnerDefaultsResult = {
  partnerDefaults: FormDefaults | null;
  isLoading: boolean;
  error: string | null;
};

export const readPartnerIdFromUrl = (): string | null => {
  return new URLSearchParams(window.location.search).get('partner_id');
};

export const usePartnerDefaults = (leadsService: ILeadsService): UsePartnerDefaultsResult => {
  const [partnerDefaults, setPartnerDefaults] = useState<FormDefaults | null>(null);
  const [isLoading, setIsLoading] = useState(() => readPartnerIdFromUrl() !== null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const partnerId = readPartnerIdFromUrl();
    if (!partnerId) return;

    let cancelled = false;

    leadsService
      .getPartnerPreload(partnerId)
      .then(data => {
        if (cancelled) return;
        setPartnerDefaults(mapPartnerDataToFormDefaults(data));
        setIsLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setError('Unable to load partner preferences. Please fill in the form manually.');
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [leadsService]);

  return { partnerDefaults, isLoading, error };
};
